(() => {
  'use strict';
  const builder = document.querySelector('[data-quote-endpoint]');
  const form = builder?.closest('form');
  if (!form) return;
  const status = form.querySelector('[data-quote-status]');
  const button = form.querySelector('button[type="submit"]');
  const originalLabel = button.textContent;
  const pendingKey = 'nzc-club-submission-v1';
  let busy = false;
  const show = (text, error = false) => {
    status.hidden = false;
    status.className = error ? 'nzc-form-errors' : 'nzc-info-card';
    status.setAttribute('role', error ? 'alert' : 'status');
    status.textContent = text;
    status.focus();
  };
  const field = name => String(new FormData(form).get(name) || '').trim();
  form.addEventListener('submit', async event => {
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy || !form.reportValidity()) return;
    let items;
    try { items = JSON.parse(localStorage.getItem('nzc-club-quote-v1') || '[]'); }
    catch { items = []; }
    if (!Array.isArray(items) || !items.length) return show('Add at least one product option to your club quote before submitting. You can contact our team for a general enquiry.', true);
    const helmetKitIds = ['9844027130169','9844026900793','9844005896505','9844005863737','9844003897657','9844002619705','9843999473977','9843983515961','9843982991673','9843978535225','15394464465217'];
    const incompleteHelmet = items.some(item => {
      const measurementNeeded = helmetKitIds.includes(String(item.productId)) || item.helmetMeasurementRequired;
      const sizeNeeded = measurementNeeded || (String(item.productId) === '9843951862073' && /with helmet/i.test(item.option || ''));
      return (sizeNeeded && !item.helmetSize) || (measurementNeeded && (!Number.isFinite(Number(item.helmetHeadCm)) || Number(item.helmetHeadCm) < 30 || Number(item.helmetHeadCm) > 80));
    });
    if (incompleteHelmet) return show('Choose the helmet size and enter the head measurement for your kit: remove the incomplete kit from this quote, open its product page and add it again with its helmet details.', true);
    const needs = Array.from(form.querySelectorAll('.nzc-equipment-needs input:checked')).map(input => input.value).join(', ');
    const helmetDetails = items.filter(item => item.helmetSize).map(item => `${item.quantity} x ${item.title} | ${item.option} | Variant ${item.variantId}`).join('\n');
    const body = {
      club:field('contact[Club or school]'),name:field('contact[name]'),email:field('contact[email]').toLowerCase(),phone:field('contact[phone]'),
      players:field('contact[Number of players]'),ageGroup:field('contact[Age group]'),requiredBy:field('contact[Required by]'),budget:field('contact[Budget]'),
      message:[field('contact[body]'),needs ? 'Additional equipment interests: '+needs : '',helmetDetails ? 'Kit helmet size selections (include these sizes when approving the quote):\n'+helmetDetails : ''].filter(Boolean).join('\n'),
      website:field('nzc_quote_website'),items:items.map(item=>({variantId:String(item.variantId),quantity:Number(item.quantity)})).sort((a,b)=>a.variantId.localeCompare(b.variantId))
    };
    busy = true; button.disabled = true; button.textContent = 'Submitting quote…';
    let pending;
    try {
      const digest = await crypto.subtle.digest('SHA-256',new TextEncoder().encode(JSON.stringify(body)));
      const hash = Array.from(new Uint8Array(digest),byte=>byte.toString(16).padStart(2,'0')).join('');
      pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (pending && pending.hash !== hash) {
        show('A previous request is awaiting confirmation. Keep reference '+pending.reference+' and contact our team before submitting a changed quote.',true);
        return;
      }
      if (!pending) {
        const requestId = crypto.randomUUID();
        pending = {requestId,hash,reference:'ICS-'+requestId.toUpperCase()};
        sessionStorage.setItem(pendingKey,JSON.stringify(pending));
      }
      const response = await fetch(builder.dataset.quoteEndpoint,{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({...body,requestId:pending.requestId}),signal:AbortSignal.timeout(25000),credentials:'same-origin'
      });
      let result;
      try { result = await response.json(); } catch { throw new Error('The quote service could not be reached.'); }
      if (!response.ok || !result.ok) {
        // Validation/configuration failures happen before draft creation and may be corrected.
        if ([400,401,413,415,422,429].includes(result.status || response.status) || result.code === 'NOT_CONFIGURED') sessionStorage.removeItem(pendingKey);
        throw new Error(result.message || 'We could not confirm your request.');
      }
      sessionStorage.removeItem(pendingKey);
      localStorage.removeItem('nzc-club-quote-v1');
      const total = result.retailProducts ? ' Catalogue products estimate: ₹'+Number(result.retailProducts).toFixed(2)+'.' : '';
      show('Quote request received. Reference: '+result.reference+'.'+total+' Our team will review products, availability, delivery and your final discounted price. This is not an approved order or a payment request.');
      button.textContent = 'Quote received';
      builder.querySelectorAll('input,button').forEach(control=>control.disabled=true);
      button.disabled = true;
      busy = true;
    } catch (error) {
      show((error.message || 'We could not confirm your request.')+(pending ? ' Keep reference '+pending.reference+'. Retry with the same details or contact our team.' : ' Please contact our team.'),true);
      busy = false;
    } finally {
      if (!busy || button.textContent !== 'Quote received') { busy = false; button.disabled = false; button.textContent = originalLabel; }
    }
  }, true);
})();
